/** @jsxImportSource @emotion/react */
import { Paper, useMediaQuery, useTheme } from '@mui/material';

function ElevatedGrid(props) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))

    let css = {
        paper : { borderRadius: "15px", padding: "20px", ...(props.customCss ? props.customCss : {}) }
    }
    return (!isSmallScreen ? 
        <Paper elevation={2} css={css.paper}>
            {props.children}
        </Paper>
        : 
        props.children
    );
}

export default ElevatedGrid;